import ActividadTile from './ActividadTile';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaQrcode, FaCalendarAlt, FaUserFriends, FaChartBar } from 'react-icons/fa';
import { RoleLayout, RoleGrid, RoleTile } from './RoleShell';

export default function Socio() {
  const navigate = useNavigate();

  return (
    <RoleLayout
      title="Panel — Socio"
      subtitle="Accede a tus herramientas principales de reservas, invitaciones y escaneo en puerta."
      roleLabel="Rol: Socio"
    >
      <RoleGrid>
        <ActividadTile/>
        <RoleTile
          icon={FaCalendarAlt}
          label="Reservas"
          description="Gestiona las reservas que corresponden a tus zonas."
          onClick={() => navigate('/dashboard/reservas')}
        />

        {/* ✅ NUEVO: Panel de administración de reservas */}
        <RoleTile
          icon={FaChartBar}
          label="Panel de Reservas"
          description="Administra reservas por evento (tabla, filtros, exportación y acciones)."
          onClick={() => navigate('/admin/reservas-panel')}
        />

        <RoleTile
          icon={FaUserFriends}
          label="Generar invitaciones"
          description="Crea invitaciones con QR para tus invitados."
          onClick={() => navigate('/dashboard/invitaciones')}
        />
        <RoleTile
          icon={FaQrcode}
          label="Escanear invitaciones"
          description="Escanea y valida invitaciones al ingreso."
          onClick={() => navigate('/escanear')}
        />
      </RoleGrid>
    </RoleLayout>
  );
}
